import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import jwtDecode from 'jwt-decode'

function useIsManager() {
  const event = useSelector(state => state.event.event)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const authentication = useSelector(state => state.authentication)

  return useMemo(() => {
    //if the event , the organizers and a user is logged in
    if (event && event.organizers && !isEmpty(authenticatedUser)) {
      //NOTE: proof of concept on where to get group data
      //console.log(jwtDecode(authenticatedUser.token).groups)
      //we want to check the role of the authenticated user so we verify that superadmin is included on the groups array on the user token
      const splicedToken = authentication.token.slice(7)
      try {
        if (jwtDecode(splicedToken).groups.includes('superadmin')) {
          return true
        } else {
          //check to see if the user id matches one of the numbers found in the organizer list and return true
          return event.organizers.find(
            x => Number(x.user_id) === Number(authenticatedUser.user_id)
          )
        }
      } catch (err) {
        return event.organizers.find(
          x => Number(x.user_id) === Number(authenticatedUser.user_id)
        )
      }
    } else {
      //fail state is false
      return false
    }
  }, [
    event.organizers,
    authenticatedUser.user_id,
    authenticatedUser,
    authentication
  ])
}

export default useIsManager



// WEBPACK FOOTER //
// ./src/hooks/useIsManager.js